/**
 * Created by svitlana.i on 10/26/2017.
 */
export class HashHelper {
    public static hashCode(str: string) { // java String#hashCode
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    }
}


// WEBPACK FOOTER //
// ./app/common/helpers/hashHelper.ts